  <template>
    <div>
      <v-data-table :headers="headers" :items="empAttends" :search="search" hide-default-footer item-key="_id"
        @page-count="pageCount = $event" :page.sync="page" :items-per-page="itemsPerPage" dense
        no-data-text="No hay resultados" no-result-text="No hay resultados">
        <template v-slot:top>
          <v-row class="px-3">
            <v-col cols="12" sm="6">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                hide-details></v-text-field>
            </v-col>
            <slot name="filter" />
          </v-row>
        </template>

        <template v-slot:item.isAttend="{ item }">
          <v-simple-checkbox :value="item.isAttend" @input="toggleAttend(item)"></v-simple-checkbox>
        </template>

        <template v-slot:item.extraHours="{ item }">
          <v-text-field type="number" max="99" :error="extraHourError === item._id"
            :error-messages="extraHourError && extraHourError === item._id && 'Inválido'" :disabled="!item.isAttend"
            class="extra-input" @input="updateExtraDebounced(item, $event)" :value="item.extraHours"></v-text-field>
        </template>

        <template v-slot:item.img="{ item }">
          <img :src="item.img || require('@/assets/imgs/no-img.png')" alt="imagen" class="emp-img" />
        </template>

        <!-- <template v-slot:no-results>No hay resultados</template> -->
        <template v-slot:footer>
          <v-pagination class="py-5" v-model="page" :length="pageCount" :total-visible="10">
          </v-pagination>
        </template>
      </v-data-table>
    </div>
  </template>

<script>
import { tableHeader } from '@/services/constData.js';
export default {
  props: {
    empAttends: Array
  },
  created() {
    this.headers = tableHeader.attend;
  },
  data() {
    return {
      search: '',
      page: 1,
      itemsPerPage: 20,
      pageCount: 0,
      extraHourError: null
    };
  },
  methods: {
    updateExtraDebounced(emp, value) {
      clearTimeout(this.extraHourTimeout);
      this.extraHourTimeout = setTimeout(() => {
        this.updateExtra(emp, value);
      }, 500);
    },
    updateExtra(emp, value) {
      if (value > 99) {
        this.extraHourError = emp._id;
        return;
      } else if (emp._id === this.extraHourError) {
        this.extraHourError = null;
      }
      const updatedEmp = { ...emp, extraHours: +value }
      this.updateEmpAttend(updatedEmp);
    },
    toggleAttend(emp) {
      const empAttendToUpdate = { ...emp, isAttend: !emp.isAttend }
      this.updateEmpAttend(empAttendToUpdate);
    },
    updateEmpAttend(empAttendToUpdate) {
      this.$store.dispatch('updateEmpAttend', { empAttendToUpdate });
    }
  },
  computed: {
    attend() {
      return this.$store.getters.attend;
    }
  }
}
</script>

<style lang='scss'>
.extra-input {
  width: 50px;
}
</style>